import { Button } from "@material-ui/core";
import React, { Children } from "react";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import colors from "../../styles/colors";
import CustomTooltip from "./CustomTooltip";

import * as actionCreators from "../../actions/tour";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import store from "../../store";

const style = {
  title: {
    fontFamily: "Poppins-Regular",
    fontSize: 24,
    fontWeight: "bold",
    color: colors.primary,
  },
  text: {
    fontFamily: "Poppins-Regular",
    textAlign: "left",
    color: colors.primary,
  },
};

const hideTour = () => {
  store.dispatch(actionCreators.hideTour());
};

const handleJoyrideCallback = (data) => {
  const { action, index, status, type } = data;

  // End of tour reached or tour skipped
  if ([STATUS.PAUSED, STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
    hideTour();
  }

  //Fired when user clicks outside of tour
  if (action === ACTIONS.CLOSE) {
    hideTour();
  }
};

const GuidedTour = (props) => {
  const steps = [
    {
      target: "body",
      placement: "center",
      content: (
        <div>
          <h1 style={style.title}>Welcome To AC Health</h1>
          <div style={style.text}>
            <p>
              The Tutorial takes 5 minutes. You can return to the Tutorial
              anytime from the left navigation menu.
            </p>
            <p>The Tutorial will cover:</p>
            <ol>
              <li>The channel dashboard</li>
              <li>Adding a new patient/client</li>
              <li>Managing your patient/client list</li>
              <li>App subscriptions</li>
              <li>Main navigation</li>
            </ol>
          </div>
        </div>
      ),
    },
    {
      target: ".step_2",
      content: (
        <div>
          <h1 style={style.title}>Channel Dashboard</h1>
          <div style={style.text}>
            The Pencil takes you to your Channel Dashboard where you can manage:
            Channel cover information, Library content, Client satisfaction
            surveys, NPS Surveys, Compliance Rewards and Survey Reporting.
          </div>
        </div>
      ),
    },
    {
      target: ".step_3",
      content: (
        <div>
          <h1 style={style.title}>Add Patient/Client</h1>
          <div style={style.text}>
            This is where you can Add a New Patient/Client.
          </div>
        </div>
      ),
    },
    {
      target: ".step_4",
      content: (
        <div>
          <h1 style={style.title}>Manage Patients/Clients</h1>
          <div style={style.text}>
            This is where you can manage your Patient/Client care plans,
            copy/paste care plans into EMR and other Notes, supervise
            compliance, add/manage goals and progress content, send individual
            messages, send broadcast messages to multiple patients/clients,
            discharge/reactivate and remove patients/clients from your channel.
          </div>
        </div>
      ),
    },
    {
      target: ".step_5",
      content: (
        <div>
          <h1 style={style.title}>Manage Your Subscription Plan</h1>
          <div style={style.text}>
            This is where you can add a paid subscription to the channel after
            the 30-day trial ends, clone a channel and delete a channel.
          </div>
        </div>
      ),
    },
    {
      target: ".step_6",
      content: (
        <div>
          <h1 style={style.title}>Channel Dashboard</h1>
          <div style={style.text}>
            Click here to return to the My Channels screen from anywhere on the
            platform.
          </div>
        </div>
      ),
    },
    {
      target: ".step_7",
      content: (
        <div>
          <h1 style={style.title}>External Resources</h1>
          <div style={style.text}>
            This is our patient resources section where you will find summaries
            of great books, podcasts and articles covering a wide range of
            Health, Fitness and Recovery topics.
          </div>
        </div>
      ),
    },
    {
      target: ".step_8",
      content: (
        <div>
          <h1 style={style.title}>Your Messages</h1>
          <div style={style.text}>
            Read, reply and manage messaging threads.
          </div>
        </div>
      ),
    },
    {
      target: ".step_9",
      content: (
        <div>
          <h1 style={style.title}>Manage Account</h1>
          <div style={style.text}>
            Manage your email address, password, and basic account information.
          </div>
        </div>
      ),
    },
    {
      target: ".step_10",
      content: (
        <div>
          <h1 style={style.title}>Logout</h1>
          <div style={style.text}>
            Leave the Portal to refresh after an update.
          </div>
        </div>
      ),
    },
  ];

  return (
    <Joyride
      steps={steps}
      run={props.tour.tourVisible}
      continuous={true}
      locale={{
        back: "Back",
        close: "Close",
        last: "Done",
        next: "Next",
        open: "Open the dialog",
        skip: "Skip",
      }}
      tooltipComponent={CustomTooltip}
      callback={handleJoyrideCallback}
      styles={{
        options: {
          primaryColor: "#FAA22B",
        },
      }}
    />
  );
};

function mapStateToProps({ tour }) {
  return {
    tour,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(GuidedTour);



// WEBPACK FOOTER //
// ./src/components/guide/GuidedTour.js